import { render } from "./ProjectDetail.vue?vue&type=template&id=0a381e87"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__